var _path, _path2, _rect, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZip = function SvgZip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#zip_svg__a)",
    d: "M9 7.5A4.5 4.5 0 0 1 13.5 3H30c8.284 0 15 6.716 15 15v22.5a4.5 4.5 0 0 1-4.5 4.5h-27A4.5 4.5 0 0 1 9 40.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0BEBE",
    fillRule: "evenodd",
    d: "M28.5 24H24v1.5h1.5V27H24v1.5h1.5V30H24v1.5h1.5V33H24v6h6v-4.5h-1.5V33H30v-1.5h-1.5V30H30v-1.5h-1.5V27H30v-1.5h-1.5zm-3 12h3v1.5h-3z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25.5,
    height: 12,
    x: 3,
    y: 9,
    fill: "#67CE00",
    rx: 4.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.389 18v-.902l2.836-3.785H9.4V12H14.3v.902l-2.836 3.786h2.824V18zm7.333-6v6h-1.629v-6zm.772 6v-6h2.59q.668 0 1.17.264.5.264.778.74.279.479.279 1.117 0 .645-.287 1.116-.285.472-.8.727-.513.255-1.198.255h-1.547v-1.266h1.218q.288 0 .49-.1a.73.73 0 0 0 .313-.29.85.85 0 0 0 .111-.442.83.83 0 0 0-.11-.44.7.7 0 0 0-.314-.28 1.1 1.1 0 0 0-.49-.1h-.574V18z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "zip_svg__a",
    x1: 9,
    x2: 45,
    y1: 45,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FAFC"
  })))));
};
export default SvgZip;